import { zApplicationListForResidenceData } from '@repo/sdk/zod'
import { z } from 'zod'

const filterShape =
	zApplicationListForResidenceData.shape.body.shape.filters.shape

/**
 * The filters, the search and the page of the list of applications, as the
 * address holds them.
 */
export const applicationsSearchSchema = z.object({
	state: filterShape.state.optional(),
	category: filterShape.category.optional(),
	quota: filterShape.quota.optional(),
	review: filterShape.reviewState.optional(),
	origin: filterShape.origin.optional(),
	openFlags: filterShape.openFlags.optional(),
	afterCall: filterShape.afterCall.optional(),
	search: z.string().trim().default(''),
	page: z.number().int().min(1).default(1)
})
